<template>
  <div v-if="!progress">
    <v-col
      v-if="alreadySent">
      <v-btn
        outlined
        @click="cancel">
        リクエストを取り消す
      </v-btn>
    </v-col>
    <v-col
      v-else>
      <v-btn
        outlined
        @click="request">
        リクエストを送る
      </v-btn>
    </v-col>
  </div>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { RequestRepository } from '@/repository/RequestRepository.js'

export default {
  name: "StatusConditions",
  data() {
    return{
      teacher: this.$store.getters.teacher,
      progress: true,
      inRequestStudentIds: [],
    }
  },
  props: {
    student: Object,
  },
  methods: {
    request(){
      this.$emit("request", this.student)
      this.inRequestStudentIds.push(this.student.id)
    },
    cancel() {
      this.$emit("cancel", this.student)
      this.inRequestStudentIds.splice(this.student.id)
    }
  },
  created: async function() {
    const requestRepo = new RequestRepository(firestore)
    const requests = await requestRepo.listOfInRequest(this.student.parentId)
    const inRequests = requests.filterBySenderId(this.teacher.uuid)
    this.inRequestStudentIds = inRequests.getStudentIds()
    this.progress = false
  },
  computed: {
    alreadySent() {
      return this.inRequestStudentIds.includes(this.student.id)
    }
  }
}

</script>

